export const LOADED = 'LOADED';
export const LOADING = 'LOADING';
export const CONFIGURE_USER = 'CONFIGURE_USER';
export const BAD_USER = 'BAD_USER';
export const SET_ALL_SEGMENTS = 'SET_ALL_SEGMENTS';
export const SET_OUTBOXES = 'SET_OUTBOXES'; 
